module.exports = __webpack_public_path__ + "static/img/back.1745385299907.jpg";